module.exports = __webpack_public_path__ + "static/media/icon.55694d4e.png";